module.exports = __webpack_public_path__ + "media/145.248c1c90.mp3";